<template>
  <StandardResourceService title="AI营销活动" :tab-list="tabList" v-model="activeTab">
    <ActivityListTab v-if="activeTab === 'activityList'"/>
  </StandardResourceService>
</template>

<script>
import StandardResourceService from '@/customComponents/standard/StandardResourceService.vue'
import ActivityListTab from '@/views/service_new/aiMarketing/components/ActivityListTab.vue'

export default {
  name: 'AiMarketingService',
  components: {
    StandardResourceService,
    ActivityListTab
  },
  data() {
    return {
      activeTab: 'activityList',
      tabList: [
        { label: '活动列表', key: 'activityList' }
      ]
    }
  }
}
</script>

<style scoped lang="less">
</style>
